(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import { createContext } from 'react';
import { css } from 'styled-components';
import { BREAKPOINTS } from "../constants/responsive";
var ranges = Object.entries(BREAKPOINTS).reduce(function (acc, curr, index, arr) {
  var _curr = _slicedToArray(curr, 2),
      label = _curr[0],
      upperBoundary = _curr[1];

  var prevItem = arr[index - 1] || []; // eslint-disable-next-line no-unused-vars

  var _prevItem = _slicedToArray(prevItem, 2),
      prevLabel = _prevItem[0],
      _prevItem$ = _prevItem[1],
      prevUppperBoundary = _prevItem$ === void 0 ? 0 : _prevItem$;

  acc[label] = {
    from: prevUppperBoundary + 1,
    to: upperBoundary
  };
  return acc;
}, {});
export var media = Object.entries(ranges).reduce(function (acc, curr, index, arr) {
  var _curr2 = _slicedToArray(curr, 2),
      label = _curr2[0],
      range = _curr2[1];

  var minWidth = "(min-width: ".concat(range.from, "px)");
  var maxWidth = "(max-width: ".concat(range.to, "px)");
  var mediaQueries = {
    up: minWidth,
    down: maxWidth,
    only: "".concat(minWidth, " and ").concat(maxWidth)
  };
  acc.css[label] = {
    only: function only() {
      return function () {
        return css(["@media ", "{", ";}"], mediaQueries.only, css.apply(void 0, arguments));
      };
    },
    and: function and(direction) {
      return function () {
        return css(["@media ", "{", ";}"], mediaQueries[direction], css.apply(void 0, arguments));
      };
    }
  };
  acc.matches[label] = {
    only: function only() {
      return window.matchMedia(mediaQueries.only).matches;
    },
    and: function and(direction) {
      return window.matchMedia(mediaQueries[direction]).matches;
    }
  };
  return acc;
}, {
  css: {},
  matches: {}
});
export var MediaContext = createContext();
var _default = {
  media: media
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ranges, "ranges", "/home/vsts/work/1/s/src/helpers/responsive.js");
  reactHotLoader.register(media, "media", "/home/vsts/work/1/s/src/helpers/responsive.js");
  reactHotLoader.register(MediaContext, "MediaContext", "/home/vsts/work/1/s/src/helpers/responsive.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/helpers/responsive.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();